import { createContext, useContext } from 'react';
import type { IconStyle } from './icon-style.context';

export interface IconStylePreferenceValue {
  /** The user's choice, Candy by default. */
  style: IconStyle;
  /** The saved choice is back, so a change can be taken. */
  ready: boolean;
  setStyle: (style: IconStyle) => void;
}

export const IconStylePreferenceContext =
  createContext<IconStylePreferenceValue>({
    style: 'plain',
    ready: false,
    setStyle: () => {},
  });

/** The icon style setting, for Appearance. */
export function useIconStyleSetting(): IconStylePreferenceValue {
  return useContext(IconStylePreferenceContext);
}
